module.exports = __webpack_public_path__ + "img/call.f877de2d.png";